import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuspensionRisk = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6450_157659)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
				fill: "#37003C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.46864 12.3918L5.13114 12.853C4.72239 12.913 4.34364 12.6243 4.28739 12.2155L3.51489 6.65805C3.45864 6.24555 3.74364 5.8668 4.15614 5.81055L6.87864 5.43555V9.50055C6.87864 10.3293 7.55364 11.0005 8.37864 11.0005H9.03489L9.10989 11.5443C9.16614 11.9568 8.88114 12.3355 8.46864 12.3918Z",
				fill: "#FEDA00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5002 3.89063V9.50063C12.5002 9.91313 12.1627 10.2506 11.7502 10.2506H8.37891C7.96641 10.2506 7.62891 9.91313 7.62891 9.50063V3.89063C7.62891 3.47438 7.96641 3.14062 8.37891 3.14062H11.7502C12.1627 3.14062 12.5002 3.47438 12.5002 3.89063Z",
				fill: "#FEDA00"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6450_157659",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgSuspensionRisk;
